import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import CloseIcon from '@mui/icons-material/Close';
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, IconButton } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import CustomerSelection from "../../CustomerSelection"


export default function ChangeServiceOrderCustomerModal({
    serviceOrder,
    open,
    closeModal,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [customer, setCustomer] = React.useState({
        customer: {},
        createNewCustomer: false,
        editingCustomer: false,
        editedCustomer: {}
    })
    const [updateCustomerItem, setUpdateCustomerItem] = React.useState(true)
    const [saving, setSaving] = React.useState(false)

    React.useEffect(() => {
        setCustomer({
            customer: {},
            createNewCustomer: false,
            editingCustomer: false,
            editedCustomer: {}
        })
        setUpdateCustomerItem(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const save = (event) => {
        setSaving(true)
        const new_customer = {
            customer_id: customer.customer.id,
            update_customer_item: updateCustomerItem,
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/update_customer`, new_customer).then((serviceOrder) => {
                setSaving(false)
                enqueueSnackbar('Successfully changed customer', { variant: 'success' })
                closeModal(serviceOrder.data.data)
            }).catch((error) => {
                setSaving(false)
                enqueueSnackbar(`Failed to change customer <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                maxWidth={'md'}
                fullWidth={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <LoadingBackdropIndeterminate
                    open={saving}
                    text={"Updating Service Order Customer"}
                />
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>Update Service Order Customer</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Grid container direction="column" spacing={2} sx={{ minWidth: '300px' }}>
                            <Grid size="grow">
                                <CustomerSelection
                                    autoFocus={true}
                                    updateFunction={setCustomer}
                                    customerData={customer}
                                    includePreferredContact={false}
                                    allowCreate={false}
                                    allowEdit={false}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save} disabled={saving || !customer.customer.id || customer.customer.id === serviceOrder.customer_id}>
                                Update
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
